"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _ModalPortal = _interopRequireDefault(require("./ModalPortal"));

var _omit = _interopRequireDefault(require("lodash/omit"));

var _some = _interopRequireDefault(require("lodash/some"));

var _findLast = _interopRequireDefault(require("lodash/findLast"));

var _map = _interopRequireDefault(require("lodash/map"));

var _keys = _interopRequireDefault(require("lodash/keys"));

var _bodyScrollLockManager = _interopRequireDefault(require("../../util/bodyScrollLockManager"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactTransitionGroup = require("react-transition-group");

var _ActionRoot = require("../../higher-order/ActionRoot");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This is the root level component that is responsible for displaying the visible modals.
var ModalContainer = (0, _createReactClass.default)({
  displayName: "ModalContainer",
  events: function events() {
    return {
      SHOW_MODAL: this.showModal,
      HIDE_MODAL: this.hideModal
    };
  },
  componentDidMount: function componentDidMount() {
    // This is non-standard, don't use this an example! We do it this way because
    // we don't actually want to manage the modals through the prop tree, because
    // that would result in circular updates: triggering SHOW_MODAL would result in
    // adding props which would bubble down to the newly shown Modal, which would
    // updated itself because it thinks props have changed. In that design, the update
    // would require triggering another event, thus starting the cycle all over again.
    this.context.dispatcher.register(this, {
      autoBind: false
    });
  },
  showModal: function showModal(e) {
    var state = {};
    state[e.data.modalKey] = e.data;
    this.setState(state);
  },
  hideModal: function hideModal(e) {
    // A modal will always be hidden on "HIDE_MODAL", even if its isOpen prop is not correctly set to false.
    var modalKey = e.data.modalKey;
    var state = (0, _omit.default)(this.state, modalKey); // No more modals are visible.

    if (!(0, _some.default)(state)) {
      _bodyScrollLockManager.default.unlock();
    }

    this.replaceState(state);
  },
  close: function close(modalKey) {
    this.context.dispatcher.emit("HIDE_MODAL", {
      modalKey: modalKey
    });
  },
  render: function render() {
    var modals = this.state || {};
    var modalKeys = (0, _keys.default)(modals);
    var lockScrollBar = (0, _some.default)(modals, function (m) {
      return !m.allowScrollBar;
    });
    var components = [];
    var hideOnClickKey;
    var handleClick;

    if (modalKeys) {
      hideOnClickKey = (0, _findLast.default)(modalKeys, function (key) {
        return modals[key].shouldCloseOnOverlayClick;
      });

      if (hideOnClickKey) {
        handleClick = this.close.bind(this, hideOnClickKey);
      }

      components = (0, _map.default)(modalKeys, function (key) {
        var modal = modals[key];
        return (
          /*#__PURE__*/
          // eslint-disable-next-line
          _react.default.createElement("div", {
            key: key,
            className: (0, _classnames.default)("modal-overlay", modal.customOverlayClassName),
            onClick: handleClick,
            role: "dialog"
          }, /*#__PURE__*/_react.default.createElement(_ModalPortal.default, modal))
        );
      });
    }

    return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.TransitionGroup, null, (0, _map.default)(components, function (component, i) {
      // intentional use of i as key so that re-renders don't re-transition an already visible modal
      return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
        key: i,
        timeout: 500,
        classNames: "modal",
        onEntered: function onEntered() {
          return _bodyScrollLockManager.default.lock(lockScrollBar);
        }
      }, component);
    }));
  }
});
ModalContainer.contextType = _ActionRoot.ActionRootContext;
var _default = ModalContainer;
exports.default = _default;